export default "/fonts/poppins-v9-latin-700.ttf?5e64a197e9ef7e18e0ae09b2331f9d58";